<template>
    <v-app
            id="nowyu"
            fixedFooter
    >
        <main-toolbar v-if="showToolbar()"></main-toolbar>

        <main style="padding-bottom: 56px;">
            <v-slide-y-transition mode="out-in">
                <router-view></router-view>
            </v-slide-y-transition>
        </main>

        <v-snackbar
                class="notification"
                :timeout="snackbarTimeout"
                :bottom="snackbarBottom"
                :success="snackbarColor === 'success'"
                :info="snackbarColor === 'info'"
                :warning="snackbarColor === 'warning'"
                :error="snackbarColor === 'error'"
                :primary="snackbarColor === 'primary'"
                :secondary="snackbarColor === 'secondary'"
                :multi-line="snackbarMode === 'multi-line'"
                :vertical="snackbarMode === 'vertical'"
                v-model="showSnackbar"
        >
            {{ snackbarText }}
            <v-btn
                flat
                dark
                @click.native="snack('', '')"
            ><v-icon>close</v-icon></v-btn>
        </v-snackbar>

        <footer-navigation v-if="showFooter()"></footer-navigation>
    </v-app>
</template>

<script>
    import { mapGetters } from 'vuex';

    import MainToolbar from '../components/MainToolbar';
    import FooterNavigation from '../components/FooterNavigation';

    export default {
        data() {
            return {
                showSnackbar: false,
                snackbarText: '',
                snackbarTimeout: 10000,
                snackbarBottom: true,
                snackbarColor: 'success',
                snackbarMode: '',
            };
        },
        components: {
            FooterNavigation,
            MainToolbar,
        },
        methods: {
            ...mapGetters('nav', [
                'showToolbar',
                'showFooter',
            ]),
            ...mapGetters('errors', [
                'errors',
            ]),
            showError(errors) {
                let msg = '';
                if (errors && errors.length > 0) {
                    const error = errors[errors.length - 1];
                    this.$log.error(error);

                    if (error.response) {
                        msg = error.response.data;
                    } else if (error.message) {
                        msg = error.message;
                    } else {
                        msg = JSON.stringify(error);
                    }
                }

                this.snack(msg, 'error');
            },
            snack(msg, color) {
                this.snackbarText = msg;
                this.snackbarColor = color;
                this.snackbarMode = (msg && msg.length > 100) ? 'multi-line' : '';
                this.showSnackbar = (msg !== '');
            },
            errorsChanged(oldValue, newValue) {
                this.showError(newValue);
            },
        },
        created() {
            this.$store.watch(
                (state) => {
                    this.$log.debug('state');
                    return state.errors.errors;
                },
                this.errorsChanged,
            );
        },
    };
</script>

<style lang="stylus">
    #main-navigation
        border-width: 0pt;

    body
        font-family Quicksand;
</style>



// WEBPACK FOOTER //
// MainLayout.vue?5a552210